import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {faLink} from '@fortawesome/free-solid-svg-icons';
import { CONTACT_EMAIL } from "../seo.js";
function Footer(){
  return (

<footer className="footer py-4">
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-4 text-lg-start">
        Copyright &copy; Pentagon Properties 2025
      </div>
      <div className="col-lg-4 my-3 my-lg-0">
        <a className="btn btn-dark btn-social mx-2" href="tel:+19022259634" aria-label="Phone">
        <FontAwesomeIcon icon={faPhone} />
        </a>
        <a className="btn btn-dark btn-social mx-2" href={`mailto:${CONTACT_EMAIL}`} aria-label="Mail">
        <FontAwesomeIcon icon={faEnvelope} />
        </a>
        <a className="btn btn-dark btn-social mx-2" href="https://www.linkedin.com/in/iancarver" aria-label="LinkedIn">
          <FontAwesomeIcon icon={faLink} />
        </a>
      </div>
      <div className="col-lg-4 text-lg-end">
        <a className="link-dark text-decoration-none me-3" href="#!">
          Privacy Policy
        </a>
        <a className="link-dark text-decoration-none" href="#!">
          Terms of Use
        </a>
      </div>
    </div>
  </div>
</footer>

    )}
    export default Footer
